import * as React from "react";
import * as _ from "lodash";
import { Dispatch, connect } from "react-redux";
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IDonorShieldHistoryReportResponse } from "@nkr/store/index";
import DonorShieldReportGrid from "./donor-shield-history-grid";

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps { }

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getDonorShieldReport: (startDate: string, endDate: string, centerId: number, organType: number) => Promise<IDonorShieldHistoryReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
}

class DonorShieldReport extends React.Component<TProps, IState> {
    render = () => {
        return (
            <>
                <DonorShieldReportGrid
                    getDonorShieldReport={this.props.getDonorShieldReport}
                    showLoading={this.props.showLoading}
                    hideLoading={this.props.hideLoading}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getDonorShieldReport: (startDate, endDate, centerId, organType) => {
            return dispatch(ReportActionCreators.getDonorShieldReport(startDate, endDate, centerId, organType));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorShieldReport);